import React, { Suspense, lazy, useEffect } from "react"
import { Routes, Route, useLocation } from "react-router"
import { trackPageView } from "@/lib/analytics"

// Lazy-load pages for code splitting
const HomePage = lazy(() => import("./pages/HomePage.tsx"))
const AboutPage = lazy(() => import("./pages/AboutPage.tsx"))
const SearchPage = lazy(() => import("./pages/SearchPage.tsx"))
const BusinessDetailPage = lazy(() => import("./pages/BusinessDetailPage.tsx"))
const ClaimPage = lazy(() => import("./pages/ClaimPage.tsx"))
const StatePage = lazy(() => import("./pages/StatePage.tsx"))
const CityPage = lazy(() => import("./pages/CityPage.tsx"))
const CategoryPage = lazy(() => import("./pages/CategoryPage.tsx"))
const RequestLinkPage = lazy(() => import("./pages/RequestLinkPage.tsx"))
const VerifyPage = lazy(() => import("./pages/VerifyPage.tsx"))
const AdminLoginPage = lazy(() => import("./pages/AdminLoginPage.tsx"))
const AdminPage = lazy(() => import("./pages/AdminPage.tsx"))
const MyBusinessPage = lazy(() => import("./pages/MyBusinessPage.tsx"))
const NotFoundPage = lazy(() => import("./pages/NotFoundPage.tsx"))

function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
    </div>
  )
}

let lastTrackedPath = ""

function RoutePageViewTracker() {
  const location = useLocation()

  useEffect(() => {
    const nextPath = `${location.pathname}${location.search}`
    if (nextPath === lastTrackedPath) return
    lastTrackedPath = nextPath
    trackPageView("route_change")
  }, [location.pathname, location.search])

  return null
}

export function App() {
  return (
    <>
      <RoutePageViewTracker />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/business/:id" element={<BusinessDetailPage />} />
          <Route path="/claim/:id" element={<ClaimPage />} />
          <Route path="/us/:state" element={<StatePage />} />
          <Route path="/us/:state/:city" element={<CityPage />} />
          <Route path="/us/:state/:city/:category" element={<CategoryPage />} />
          <Route path="/auth/request-link" element={<RequestLinkPage />} />
          <Route path="/auth/verify" element={<VerifyPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/dashboard/my-business" element={<MyBusinessPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </>
  )
}
